import { render, staticRenderFns } from "./WaterLeakageCauseFixedQuestion.vue?vue&type=template&id=3bf24258&scoped=true"
import script from "./WaterLeakageCauseFixedQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageCauseFixedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf24258",
  null
  
)

export default component.exports